import { render, staticRenderFns } from "./SchemaContentShape.vue?vue&type=template&id=638fdb47&scoped=true"
import script from "./SchemaContentShape.vue?vue&type=script&lang=js"
export * from "./SchemaContentShape.vue?vue&type=script&lang=js"
import style0 from "./SchemaContentShape.vue?vue&type=style&index=0&id=638fdb47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638fdb47",
  null
  
)

export default component.exports